import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getAllSearchResults,
  getSearchResultsMap,
  clearFilters,
  clearRestaurantList,
} from "../../actions/restaurantActions";
import Loader from "react-loader-spinner";
import Results from "./Results";
import ResultsPagination from "./ResultsPagination";
import RestaurantListStyles from "../../styles/RestaurantListStyles";
import CloseIcon from "../icons/CloseIcon";
import "mapbox-gl/dist/mapbox-gl.css";
import mapboxgl from "mapbox-gl";
import SearchSortFilter from "./filtering/SearchSortFilter";
import FilteringIcon from "../icons/FilteringIcon";

const RestaurantList = ({
  history,
  restaurants,
  getAllSearchResults,
  getSearchResultsMap,
  clearRestaurantList,
  clearFilters,
}) => {
  // let currentMarkers = [];
  let clickedCardPoints = [];
  let currentMarkers = [];

  const {
    loading,
    restaurantList,
    restaurantListAll,
    restaurantSearchFilter,
    lifestyleFilter,
    cuisineFilter,
    mealFilter,
    diningFilter,
    priceFilter,
    vibeFilter,
    neighborhoodFilter,
    consciousFilter,
  } = restaurants;

  const [map, setMap] = useState(null);
  const mapContainer = useRef(null);

  const [mapView, setMapView] = useState(false);

  const [clickedCard, setClickedCard] = useState("");

  const [filtersOpen, setFiltersOpen] = useState(false);

  //pagination of results
  const [currentPage, setCurrentPage] = useState(1);
  const [resultsPerPage] = useState(8);
  //get current results
  const indexOfLastResult = currentPage * resultsPerPage;
  const indexOfFirstResult = indexOfLastResult - resultsPerPage;

  //set results to user search results
  let currentResults = restaurantList.slice(
    indexOfFirstResult,
    indexOfLastResult
  );

  useEffect(() => {
    mapboxgl.accessToken = process.env.GATSBY_MAPBOX_SECRET;
    const initializeMap = ({ setMap, mapContainer }) => {
      const map = new mapboxgl.Map({
        container: mapContainer.current,
        style:
          "mapbox://styles/graygabrielle/ck2n64wvx12061drnbumt70h1?optimize=true",
        center: [5.00723, 52.366826],
        zoom: 10.5,
        minZoom: 9.5,
        maxZoom: 17,
        trackResize: true,
      });
      const mapNavControls = new mapboxgl.NavigationControl();
      map.addControl(mapNavControls, "bottom-left");
      map.addControl(
        new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true,
          },
          trackUserLocation: true,
        }),
        "bottom-left"
      );
      map.on("load", () => {
        setMap(map);
        map.resize();
        map.scrollZoom.disable();
      });
    };
    const mapboxMap = document.querySelector(".mapboxgl-canvas");
    if (!map && !mapboxMap) initializeMap({ setMap, mapContainer });
    if (map) {
      map.resize();
      currentResults.forEach(object => {
        object.mapPoints.forEach(point => {
          const marker = new mapboxgl.Marker(point.el)
            .setLngLat(point.coordinates)
            .setPopup(point.popup)
            .addTo(map);
          //Add marker to array
          currentMarkers.push(marker);
        });
      });
      if (clickedCardPoints.length) {
        clickedCardPoints.forEach(point => {
          new mapboxgl.Marker(point.el)
            .setLngLat(point.coordinates)
            .setPopup(point.popup)
            .addTo(map);
        });
      }
    }
    return () => {
      if (currentMarkers?.length) {
        for (var i = currentMarkers.length - 1; i >= 0; i--) {
          currentMarkers[i].remove();
        }
      }
    };
    // eslint-disable-next-line
  });

  useEffect(() => {
    getSearchResultsMap(
      "5f69d9b4b28c5e1f8f369c42",
      [],
      [],
      [],
      [],
      [],
      null,
      history,
      [],
      [],
      []
    );

    //clear query out of url without triggering re-render
    window.history.replaceState(null, "", "/locate");
    // const scrollTarget = document.querySelector(".search-results__container");
    // history.search = null;
    // scrollTarget.scrollIntoView();

    //populate full list for search bar
    if (!restaurantListAll.length)
      getAllSearchResults("5f69d9b4b28c5e1f8f369c42");

    //when component unmounts
    return function () {
      //clear out filters and restaurant list
      clearFilters();
      clearRestaurantList();
      //remove event listeners
      document.removeEventListener("click", removeMap);
      document.removeEventListener("scroll", removeMapScroll);
      //clean up mapbox map
      // if (map) {
      // map.remove();
      //   console.log("removed map");
      // }
    };
    //eslint-disable-next-line
  }, []);

  //each time the list re-renders, make sure to start back on page one
  useEffect(() => {
    setCurrentPage(1);

    // const targetResults = document.querySelector(".results");
    // if (targetResults) targetResults.scrollIntoView(true);

    // const targetElement = document.querySelector(".restaurant-list");
    // if (targetElement) targetElement.scrollTop = 0;

    if (
      window.matchMedia("(pointer: coarse)").matches ||
      window.matchMedia("(hover: none)").matches
    ) {
      if (map) {
        map.resize();
        map.easeTo(
          { center: [4.88781, 52.366836], zoom: 10.5 },
          { duration: 0 }
        );
      }
    } else {
      //check window scroll pos before scroll left and up to filter bar
      const windowScrollPos = window.scrollY;
      const filterBar = document.querySelector(".filters");
      // if (filterBar) filterBar.scrollIntoView(true);
      //set vertical scroll back to where it was before scrolling filter bar into view
      window.scrollTo(0, windowScrollPos);

      if (map)
        map.easeTo(
          { center: [5.00723, 52.366826], zoom: 10.5 },
          { duration: 600 }
        );
    }

    //eslint-disable-next-line
  }, [restaurantList]);

  //choose appropriate subHeader
  let subHeader = "Loading...";
  if (restaurantList.length === 1) {
    subHeader = "Showing 1 result";
  } else if (
    (restaurantSearchFilter?.length ||
      mealFilter?.length ||
      diningFilter?.length ||
      cuisineFilter?.length ||
      lifestyleFilter?.length ||
      consciousFilter?.length ||
      priceFilter?.length ||
      neighborhoodFilter?.length ||
      vibeFilter?.length) &&
    restaurantList.length === 0 &&
    !loading
  ) {
    subHeader = "No restaurants found";
  }
  // else if (
  //   !restaurantSearchFilter?.length &&
  //   !mealFilter?.length &&
  //   !diningFilter?.length &&
  //   !cuisineFilter?.length &&
  //   !lifestyleFilter?.length &&
  //   !consciousFilter?.length &&
  //   !priceFilter?.length &&
  //   !neighborhoodFilter?.length &&
  //   !vibeFilter?.length &&
  //   !loading &&
  //   restaurantList.length > 0
  // ) {
  //   subHeader = "Showing all restaurants";
  // }
  else {
    //if current page has 8 results on it...

    if (restaurantList.length > 1 && currentResults.length === 8) {
      subHeader = `Showing ${indexOfFirstResult + 1} - ${indexOfLastResult} of 
      ${restaurantList.length}`;
    }
    //if current page has less than 8 results (must be last page with remaining results)...
    if (restaurantList.length > 1 && currentResults.length < 8) {
      subHeader = `Showing ${indexOfFirstResult + 1} - ${
        indexOfFirstResult + currentResults.length
      } of 
      ${restaurantList.length}`;
    }
  }

  //set num of filters for display
  let numOfFilters =
    mealFilter?.length +
    diningFilter?.length +
    cuisineFilter?.length +
    lifestyleFilter?.length +
    consciousFilter?.length +
    priceFilter?.length +
    neighborhoodFilter?.length +
    vibeFilter?.length;

  if (numOfFilters === 0 && restaurantSearchFilter) numOfFilters = 1;

  let filterText = "filters";
  if (numOfFilters === 1) filterText = "filter";

  const numOfFiltersText = `${numOfFilters} ${filterText}`;

  const removeMap = function (e) {
    if (
      (typeof window !== `undefined`,
      !e.target.classList.contains("search-map-box") &&
        !e.target.classList.contains("mapboxgl-map") &&
        !e.target.classList.contains("mapboxgl-canary") &&
        !e.target.classList.contains("mapboxgl-canvas-container") &&
        !e.target.classList.contains("mapboxgl-canvas") &&
        !e.target.classList.contains("mapboxgl-marker") &&
        !e.target.classList.contains("mapboxgl-control-container") &&
        !e.target.classList.contains("mapboxgl-ctrl") &&
        !e.target.classList.contains("mapboxgl-ctrl-top-right") &&
        !e.target.classList.contains("mapboxgl-ctrl-zoom-in") &&
        !e.target.classList.contains("mapboxgl-ctrl-zoom-out") &&
        !e.target.classList.contains("mapboxgl-ctrl-compass") &&
        !e.target.classList.contains("mapboxgl-ctrl-icon"))
    ) {
      const button = document.querySelector("#map-list-button");
      button.checked = false;
      setMapView(false);
      const targetMap = document.querySelector("#search-map");
      const mapContainer = document.querySelector(".search-map-box");
      if (targetMap) targetMap.classList.remove("map-full-screen");
      if (mapContainer)
        mapContainer.classList.remove("map-container-full-screen");
      document.removeEventListener("click", removeMap);
      document.removeEventListener("scroll", removeMapScroll);
    }
  };

  const removeMapScroll = function () {
    if (typeof window !== `undefined`) {
      const button = document.querySelector("#map-list-button");
      button.checked = false;
      setMapView(false);
      const targetMap = document.querySelector("#search-map");
      const mapContainer = document.querySelector(".search-map-box");
      if (targetMap) targetMap.classList.remove("map-full-screen");
      if (mapContainer)
        mapContainer.classList.remove("map-container-full-screen");
      document.removeEventListener("click", removeMap);
      document.removeEventListener("scroll", removeMapScroll);
    }
  };

  //change page
  const paginate = pageNumber => {
    switch (pageNumber) {
      case "increase":
        setCurrentPage(currentPage + 1);
        setClickedCard("");

        break;
      case "decrease":
        setCurrentPage(currentPage - 1);
        setClickedCard("");
        break;
      default:
        if (typeof pageNumber === "number") {
          setCurrentPage(pageNumber);
          setClickedCard("");
        }
    }
    if (typeof window !== `undefined`) {
      //if mobile, scroll to top of results.
      if (
        window.matchMedia("(pointer: coarse)").matches ||
        window.matchMedia("(hover: none)").matches
      ) {
        const targetElement = document.querySelector(".num-of-results-text");
        if (targetElement) targetElement.scrollIntoView(true);
        if (map) {
          map.resize();
          map.easeTo(
            { center: [4.88781, 52.366836], zoom: 10.5 },
            { duration: 0 }
          );
        }
      } else {
        const targetResults = document.querySelector(".results");
        // if (targetResults) targetResults.scrollIntoView(true);
        const targetElement = document.querySelector(".restaurant-list");
        if (targetElement) targetElement.scrollTop = 0;
        if (map)
          map.easeTo(
            { center: [5.00723, 52.366826], zoom: 10.5 },
            { duration: 600 }
          );
      }
    }
  };

  if (typeof window !== `undefined`) {
    //! change this to add event listener and remove on umount
    window.onmousedown = function (e) {
      //remove old highlighted markers and popup
      const oldMarkersCollection = document.getElementsByClassName(
        "blue-marker"
      );
      var oldMarkersArray = Array.from(oldMarkersCollection);

      const oldPopupCollection = document.getElementsByClassName(
        "mapboxgl-popup"
      );
      var oldPopupArray = Array.from(oldPopupCollection);

      if (
        !e.target.classList.contains("mapboxgl-canvas") &&
        !e.target.classList.contains("blue-marker") &&
        !e.target.classList.contains("map-list-btn") &&
        !e.target.classList.contains("map-control-container") &&
        !e.target.classList.contains("mapboxgl-ctrl-top-left") &&
        !e.target.classList.contains("mapboxgl-ctrl-top-right") &&
        !e.target.classList.contains("mapboxgl-ctrl-bottom-left") &&
        !e.target.classList.contains("mapboxgl-ctrl-bottom-right") &&
        !e.target.classList.contains("mapboxgl-ctrl") &&
        !e.target.classList.contains("mapboxgl-ctrl-zoom-in") &&
        !e.target.classList.contains("mapboxgl-ctrl-zoom-out") &&
        !e.target.classList.contains("mapboxgl-ctrl-compass") &&
        !e.target.classList.contains("mapboxgl-ctrl-icon")
      ) {
        if (oldMarkersArray.length) {
          oldMarkersArray.forEach(marker =>
            marker.parentNode.removeChild(marker)
          );
        }
        if (oldPopupArray.length) {
          oldPopupArray.forEach(popup => (popup.style.display = "none"));
        }
      }
    };
  }

  const createHighlightAndPopup = (feature, type) => {
    if (typeof window !== `undefined`) {
      const el = document.createElement("div");
      el.classList.add("marker");
      el.classList.add("blue-marker");
      el.style.backgroundImage = "url(https://i.imgur.com/bYWbdp9.png)";
      el.style.width = "24px";
      el.style.height = "30px";
      el.style.backgroundSize = "contain";
      el.style.backgroundRepeat = "no-repeat";

      const popup = new mapboxgl.Popup({
        offset: 25,
        closeButton: false,
        // closeOnClick: false,
      })
        .setHTML(
          `<div id="popup" class="popup-container"><h3 className="popup">${feature.properties.name}</h3><p className="popup">${feature.properties.street}</p><p>${feature.properties.postalCodeCity}</p></div>`
        )
        .setMaxWidth("200px");

      if (type === "add-later") {
        const coordinates = feature.geometry.coordinates;
        clickedCardPoints.push({ el, popup, coordinates });
      }

      // make a marker for each feature and add to the map
      if (type === "add-now") {
        new mapboxgl.Marker(el)
          .setLngLat(feature.geometry.coordinates)
          .setPopup(popup)
          .addTo(map);
      }
    }
  };

  const onChange = () => {
    if (typeof window !== `undefined`) {
      if (!mapView) {
        // document.querySelector(".pagination-list").scrollIntoView(true);
        // window.scrollBy(0, -100);
        setTimeout(function () {
          const button = document.querySelector("#map-list-button");
          button.checked = true;
          const targetMap = document.querySelector("#search-map");
          const mapContainer = document.querySelector(".search-map-box");
          if (targetMap) targetMap.classList.add("map-full-screen");
          if (mapContainer)
            mapContainer.classList.add("map-container-full-screen");

          document.addEventListener("click", removeMap);
          document.addEventListener("scroll", removeMapScroll);
          if (map) {
            map.resize();
            map.easeTo(
              { center: [4.88781, 52.366836], zoom: 10.5 },
              { duration: 0 }
            );
          }
          setMapView(!mapView);
        }, 200);
      }
    }
  };

  if (clickedCard) {
    if (typeof window !== `undefined`) {
      currentResults.forEach(restaurant => {
        if (
          restaurant.id === clickedCard ||
          restaurant.mongodb_id === clickedCard
        ) {
          restaurant.features.forEach(function (feature) {
            // create a HTML element for each feature
            createHighlightAndPopup(feature, "add-later");
          });
        }
      });
    }
  }

  const mapPointClicked = e => {
    if (typeof window !== `undefined`) {
      const pointClicked = e.currentTarget.id;
      let coordsStringArray = pointClicked.split("-");
      const coords = [
        parseFloat(coordsStringArray[0]),
        parseFloat(coordsStringArray[1]),
      ];
      if (!window.matchMedia("(pointer: coarse)").matches) {
        const targetId = e.currentTarget.classList[0];
        const targetElement = document.getElementById(`card-${targetId}`);
        const windowScrollPos = window.scrollY;
        targetElement.scrollIntoView(true);
        window.scrollTo(0, windowScrollPos);
      }

      currentResults.forEach(restaurant => {
        restaurant.features.forEach(function (feature) {
          if (
            feature.geometry.coordinates[0] === coords[0] &&
            feature.geometry.coordinates[1] === coords[1]
          ) {
            createHighlightAndPopup(feature, "add-now");
          }
        });
      });
    }
  };

  if (currentResults.length) {
    if (typeof window !== `undefined`) {
      currentResults.forEach(restaurant => {
        restaurant.mapPoints.forEach(point => {
          point.el.onclick = mapPointClicked;
        });
      });
    }
  }

  const addHighlightedPoints = markerId => {
    if (typeof window !== `undefined`) {
      currentResults.forEach(restaurant => {
        restaurant.features.forEach(function (feature) {
          if (feature.properties.id === markerId) {
            createHighlightAndPopup(feature, "add-now");
          }
        });
      });
    }
  };

  const seeAll = () => {
    function clearAllChecks() {
      if (typeof window !== `undefined`) {
        const dropdownArray = [
          ".sustainable-check",
          ".lifestyle-check",
          ".vibe-check",
          ".cuisine-check",
          ".meal-check",
          ".dining-check",
          ".neighborhood-check",
          ".price-check",
        ];

        dropdownArray.forEach(dropdown => {
          const dropdownChecks = document.querySelectorAll(dropdown);
          const dropdownChecksArray = Array.from(dropdownChecks);
          dropdownChecksArray.forEach(check => (check.checked = false));
        });
      }
    }

    if (typeof window !== `undefined`) {
      clearAllChecks();
      clearFilters();

      //clear query out of url without triggering re-render
      // window.history.replaceState(null, "", "/locate");
      //clear search history == important!
      history.search = null;

      getSearchResultsMap(
        "5f69d9b4b28c5e1f8f369c42",
        [],
        [],
        [],
        [],
        [],
        null,
        {
          search: "",
          state: {},
          key: "",
        },
        [],
        [],
        []
      );

      //scroll to top of  results
      const targetResults = document.querySelector(".results");
      // if (targetResults) targetResults.scrollIntoView(true);

      const targetElement = document.querySelector(".restaurant-list");
      if (targetElement) targetElement.scrollTop = 0;
    }
  };

  const clickCard = async e => {
    if (typeof window !== `undefined`) {
      //if on mobile, and map is closed...
      if (
        window.matchMedia("(pointer: coarse)").matches ||
        window.matchMedia("(hover: none)").matches
      ) {
        const cardIdComponents = e.currentTarget.id.split("-");
        cardIdComponents.splice(0, 1);
        const markerId = cardIdComponents.join("-");
        setClickedCard(markerId);
        const targetCard = document.querySelector(
          `#card-${e.currentTarget.id.split("-")[1]}`
        );
        if (targetCard) {
          targetCard.scrollIntoView(true);
        }

        setTimeout(function () {
          const button = document.querySelector("#map-list-button");
          button.checked = true;

          document.addEventListener("click", removeMap);
          document.addEventListener("scroll", removeMapScroll);
          if (map) {
            map.resize();
            map.easeTo(
              { center: [4.88781, 52.366836], zoom: 10.5 },
              { duration: 0 }
            );
          }
          setMapView(!mapView);
        }, 200);
        return;
      } else {
        const cardIdComponents = e.currentTarget.id.split("-");
        cardIdComponents.splice(0, 1);
        const markerId = cardIdComponents.join("-");
        addHighlightedPoints(markerId);

        map.easeTo(
          { center: [5.00723, 52.366826], zoom: 10.5 },
          { duration: 600 }
        );

        return;
      }
    }
  };

  const toggleFilterTakeover = () => {
    if (typeof window !== `undefined`) {
      const filtersTakeover = document.querySelector(".mobile-filters");
      if (filtersOpen) {
        setFiltersOpen(false);
        filtersTakeover.classList.add("invisible");
      } else {
        setFiltersOpen(true);
        filtersTakeover.classList.remove("invisible");
      }
    }
  };

  return (
    <>
      <div className="mobile-instructions">
        <h1 id="filter-bar" className="filter-sort-bar__instructions">
          Explore Amsterdam's best restaurants
        </h1>
        <p className="filter-sort-bar__instructions-2">
          Search from recommended eateries. Filter in new ways. Dine well, do
          good.
        </p>
        <div className="mobile-filter-btn__container">
          <div className="mobile-filter-btn" onClick={toggleFilterTakeover}>
            Search and Filter{" "}
            {numOfFilters > 0 && <span>({numOfFilters})</span>}
            <span className="filter-icon">
              <FilteringIcon />
            </span>
          </div>
        </div>
        <div className="mobile-filters invisible">
          <SearchSortFilter
            city="5f69d9b4b28c5e1f8f369c42"
            history={history}
            mobile={true}
            className="invisible"
            toggleFilterTakeover={toggleFilterTakeover}
            numOfFilters={numOfFilters}
            numOfFiltersText={numOfFiltersText}
            mapView={mapView}
          />
        </div>
      </div>

      <div className="num-of-results">
        <p className="num-of-filters-text">
          {numOfFilters > 0 && (
            <span onClick={seeAll} className="close-icon">
              <CloseIcon />
            </span>
          )}
          <span>{numOfFiltersText}</span>
        </p>
        <p className="num-of-results-text">{subHeader}</p>
      </div>
      <RestaurantListStyles>
        <div className="search-results__container">
          <div className="restaurant-list-container">
            <div
              id="restaurant-list"
              className={`restaurant-list container-relative`}
            >
              {currentPage === 1 && numOfFilters > 0 && (
                <h2 className="restaurant-list__list-header">
                  Your search results:
                </h2>
              )}
              {currentPage === 1 && numOfFilters === 0 && (
                <h2 className="restaurant-list__list-header">
                  All recommended restaurants:
                </h2>
              )}

              {loading && (
                <div className="loader-container">
                  <Loader
                    type="ThreeDots"
                    color="#231f20"
                    height={50}
                    width={50}
                  />
                </div>
              )}

              {!loading && currentResults?.length > 0 && (
                <Results
                  loading={loading}
                  restaurantList={currentResults}
                  clickCard={clickCard}
                />
              )}
              {!loading && !currentResults?.length && (
                <p className="loading">Please try broadening your search</p>
              )}
              {!loading &&
                currentResults?.length > 0 &&
                restaurantList?.length > resultsPerPage && (
                  <ResultsPagination
                    totalResults={restaurantList?.length || currentResults}
                    resultsPerPage={resultsPerPage}
                    paginate={paginate}
                    currentPage={currentPage}
                  />
                )}
            </div>
          </div>
          <input
            type="checkbox"
            id="map-list-button"
            className="map-list-btn"
            checked={mapView}
            onChange={onChange}
          />
          {currentResults.length ? (
            <label
              className="search-results__view-switch map-list-btn"
              htmlFor="map-list-button"
            >
              Map ({subHeader})
            </label>
          ) : null}

          <div className="search-map-box">
            <button className="close-map-btn">
              <svg width="24px" height="24px" viewBox="0 0 24 24">
                <g
                  id="Page-1"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g transform="translate(-380.000000, -845.000000)">
                    <g transform="translate(380.000000, 845.000000)">
                      <circle fill="#231F20" cx="12" cy="12" r="12"></circle>
                      <polygon
                        fill="#FFFFFF"
                        points="17.5 16.084 16.097 17.5 12.007 13.404 7.905 17.5 6.5 16.095 10.593 12.003 6.5 7.905 7.905 6.5 11.993 10.589 16.084 6.5 17.5 7.903 13.408 11.99"
                      ></polygon>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
            <div id="search-map" ref={mapContainer}></div>
          </div>
        </div>
        {/* <div className="center-button mb-10">
          <PillButtonLink
            targetUrl="/content/best-of/amsterdam"
            buttonText="See featured articles"
            buttonStyle="filled"
          />
        </div> */}
      </RestaurantListStyles>
    </>
  );
};

RestaurantList.propTypes = {
  restaurants: PropTypes.object.isRequired,
  getAllSearchResults: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  getSearchResultsMap: PropTypes.func.isRequired,
  clearRestaurantList: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  restaurants: state.restaurants,
});

export default connect(mapStateToProps, {
  getAllSearchResults,
  clearRestaurantList,
  getSearchResultsMap,
  clearFilters,
})(RestaurantList);
